/**
 * S3 — kategori etiketi İKİ sözlükte geliyor:
 *   kayıp ailesi (990059-990063, 990065) → '(grup yok)'
 *   stok  ailesi (990044, 990046-990050, 990064) → '(kategorisiz)'
 * Ekranda TEK kova gösterilir: '(kategorisiz)'.
 */
export const KATEGORISIZ = '(kategorisiz)';
const KAYIP_KATEGORISIZ = '(grup yok)';

export function kategoriNormalize(ad: string | null | undefined): string {
  if (!ad || ad === KAYIP_KATEGORISIZ || ad === KATEGORISIZ) return KATEGORISIZ;
  return ad;
}

/** Ekrandaki kategori adını kayıp ds'lerinin @KATEGORI sözlüğüne çevirir. */
export function kategoriKayipSozlugu(ad: string): string {
  return ad === KATEGORISIZ ? KAYIP_KATEGORISIZ : ad;
}
